module.exports = __webpack_public_path__ + "static/WEDDING E&M-503-ab15cb0da0e3ef9101d1ee32cb5f96b9.jpg";